// Hybec Air — copy-share-link button. Delegated on document so it keeps
// working after the surrounding markup is replaced (e.g. Shopify's section
// re-rendering on a variant/filter update) — the previous implementation
// was an inline <script> that located the button via sibling DOM position
// at parse time only, so its listener vanished the moment that HTML was
// replaced instead of freshly parsed.
(function () {
  if (window.__hyShareInit) return;
  window.__hyShareInit = true;

  function showToast(btn) {
    var toast = btn.nextElementSibling;
    if (!toast || !toast.classList.contains('hy-share-toast')) return;
    toast.hidden = false;
    toast.classList.add('is-visible');
    clearTimeout(toast._hyTimer);
    toast._hyTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () {
        toast.hidden = true;
      }, 250);
    }, 1800);
  }

  function copyLink(url) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(url);
    }
    return new Promise(function (resolve) {
      var tmp = document.createElement('textarea');
      tmp.value = url;
      tmp.style.position = 'fixed';
      tmp.style.opacity = '0';
      document.body.appendChild(tmp);
      tmp.select();
      try {
        document.execCommand('copy');
      } catch (e) {
        // no-op — best effort fallback for browsers without Clipboard API
      }
      document.body.removeChild(tmp);
      resolve();
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hy-share-link]');
    if (!btn) return;
    var url = btn.getAttribute('data-hy-share-link');
    if (!url) return;
    copyLink(url).then(
      function () {
        showToast(btn);
      },
      function () {
        showToast(btn);
      }
    );
  });
})();
